// size maps (tweak as you like)
const H1_SIZES = {
  xs: "text-lg md:text-[22px]", // 18px / 22px
  sm: "text-xl md:text-2xl", // 20px / 24px
  base: "text-xl sm:text-2xl md:text-[28px]", // 18px  24px / 28px
  md: "text-2xl md:text-3xl",   // 24px / 30px
  lg: "text-3xl md:text-4xl", // 30px / 36px
  "2lg": "text-4xl md:text-[40px]", // 36px / 48px
  xl: "text-4xl md:text-5xl", // 36px / 48px
  "2xl": "text-5xl md:text-6xl", // 48px / 56px
};

const P_SIZES = {
  xxs: "text-[9px] md:text-[10px]", // 10px / 12px
  xs: "text-[10px] md:text-xs", // 10px / 12px
  sm: "text-xs md:text-sm", // 12px / 14px
  // sm: "text-sm md:text-sm", // 14px / 14px
  base: "text-sm md:text-base", // 14px / 16px
  md: "text-base md:text-lg", // 16px / 18px
  lg: "text-lg md:text-xl", // 18px / 20px
  xl: "text-xl md:text-2xl", // 20px / 24px
  "2xl": "text-2xl md:text-3xl", // 24px / 30px
};

// H1
export function H1Title({ children, size = "md", className }) {
  return (
    <h1 className={`font-bold textxl font-inter text-black dark:text-white ${H1_SIZES[size]} ${className}`}>
      {children}
    </h1>
  );
}
// H1
export function H3Title({ children, size = "md", className }) {
  return (
    <h3 className={`font-bold font-inter text-black dark:text-white ${H1_SIZES[size]} ${className}`}>
      {children}
    </h3>
  );
}

// Paragraph
export function ParagraphSubTitle({ children, size = "lg", className }) {
  return (
    <p className={`text-grey ${P_SIZES[size]} ${className}`}>
      {children}
    </p>
  );
}

// Paragraph
export function Paragraph({ children, size = "lg", className }) {
  return (
    <p className={` ${P_SIZES[size]} ${className}`}>
      {children}
    </p>
  );
}
